import { type ReactElement } from 'react';

export const RoadLayerDescription = (props: { colors: string[]; lowText: string; highText: string }): ReactElement => {
    return (
        <span className="road-layer-description">
            <span>{props.lowText}</span>
            {props.colors.map((color) => (
                <span key={color} className="road-layer-description__color" style={{ backgroundColor: color }} />
            ))}
            <span>{props.highText}</span>
        </span>
    );
};
